import Link from "next/link";
import Seo from "../components/Seo";

export default function AboutPage() {
  return (
    <>
      <Seo
        title="เกี่ยวกับ KMCP Accounting"
        description="รู้จัก KMCP Accounting ขอบเขตบริการบัญชี ภาษี และจดทะเบียนธุรกิจในเชียงใหม่ พร้อมข้อมูลติดต่อและแนวทางการจัดทำบทความของเว็บไซต์"
        path="/about"
      />
      <section className="bg-white">
        <div className="mx-auto max-w-5xl px-6 py-14 sm:px-8 lg:py-20">
          <h1 className="max-w-3xl text-4xl font-semibold leading-[1.24] text-gray-950 sm:text-5xl sm:leading-[1.18]">
            เกี่ยวกับ KMCP Accounting
          </h1>
          <p className="mt-6 max-w-3xl text-lg leading-8 text-slate-600">
            KMCP Accounting ให้บริการด้านบัญชี ภาษี เงินเดือน ปิดบัญชีประจำปี และจดทะเบียนธุรกิจ โดยมีสำนักงานอยู่ในอำเภอแม่ริม จังหวัดเชียงใหม่
          </p>

          <div className="mt-10 grid gap-8 border-t border-slate-200 pt-8 lg:grid-cols-2 lg:gap-12">
            <div>
              <h2 className="text-2xl font-semibold text-gray-950">ขอบเขตบริการ</h2>
              <ul className="mt-5 space-y-3 text-base leading-7 text-slate-600">
                <li>จัดทำบัญชีและยื่นแบบภาษีตามขอบเขตที่ตกลง</li>
                <li>จัดเตรียมบัญชีเพื่อปิดรอบปีและประสานงานผู้สอบบัญชี</li>
                <li>จดทะเบียนบริษัท ห้างหุ้นส่วน และดำเนินการที่เกี่ยวข้อง</li>
                <li>จัดทำเงินเดือน ประกันสังคม และรายงานสำหรับผู้บริหาร</li>
              </ul>
              <Link href="/services/accounting" className="mt-7 inline-flex min-h-11 items-center text-sm font-semibold text-gray-950 hover:underline">
                ดูรายละเอียดบริการ <span aria-hidden className="ml-2">→</span>
              </Link>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-950">ข้อมูลธุรกิจและการติดต่อ</h2>
              <address className="mt-5 space-y-3 text-base not-italic leading-7 text-slate-600">
                <p>120/36 หมู่ 3 ตำบลดอนแก้ว อำเภอแม่ริม จังหวัดเชียงใหม่ 50180</p>
                <p><a href="tel:0822546831" className="text-gray-950 hover:underline">โทร. 082-254-6831</a></p>
                <p><a href="mailto:kmcp.acc@gmail.com" className="text-gray-950 hover:underline">kmcp.acc@gmail.com</a></p>
                <p><a href="https://line.me/R/ti/p/@kmcp.acc" target="_blank" rel="noreferrer" className="text-gray-950 hover:underline">LINE Official: @kmcp.acc</a></p>
              </address>
            </div>
          </div>

          <div className="mt-14 rounded-2xl border border-[#eadb91] bg-[#fff9dc] p-6 sm:p-8">
            <h2 className="text-2xl font-semibold text-gray-950">แนวทางการจัดทำบทความ</h2>
            <div className="mt-4 space-y-4 text-base leading-8 text-slate-700">
              <p>
                บทความเผยแพร่ภายใต้ชื่อทีม KMCP Accounting และแสดงวันที่เผยแพร่เพื่อให้ผู้อ่านประเมินความเป็นปัจจุบันของข้อมูลได้
              </p>
              <p>
                เนื้อหาในเว็บไซต์มีวัตถุประสงค์เพื่อให้ข้อมูลทั่วไป กฎหมาย ภาษี และหลักเกณฑ์ของหน่วยงานรัฐอาจมีการเปลี่ยนแปลง ผู้อ่านควรตรวจสอบข้อมูลล่าสุดจากหน่วยงานที่เกี่ยวข้องหรือขอคำแนะนำตามข้อเท็จจริงของกิจการก่อนดำเนินการ
              </p>
              <p>
                หากพบข้อมูลที่ควรแก้ไข สามารถแจ้งชื่อบทความและจุดที่ต้องการให้ตรวจสอบมาที่อีเมลของสำนักงานได้
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
